import { render } from "./user.vue?vue&type=template&id=8d1c475a&scoped=true"
import script from "./user.vue?vue&type=script&lang=js"
export * from "./user.vue?vue&type=script&lang=js"

import "./user.vue?vue&type=style&index=0&id=8d1c475a&scoped=true&lang=css"
import "./user.vue?vue&type=style&index=1&id=8d1c475a&lang=css"
script.render = render
script.__scopeId = "data-v-8d1c475a"

export default script